import { IContentAPIImageBaseRef, ImageBaseRef } from "./ImageRefBase";

export class ImageRefFactory {
    static create(imageRef: IImageRef): IContentAPIImageRef {
        return new ImageRef(imageRef).serialize();
    }
}

export class ImageRef extends ImageBaseRef {
    protected _type?: string;

    constructor(imageRef: IImageRef) {
        super(imageRef);
        this._type = imageRef.type;
    }

    serialize(): IContentAPIImageRef {
        const imageRef: IContentAPIImageRef = super.serialize();

        if (this._type !== undefined) {
            imageRef.type = this._type;
        }

        return imageRef;
    }
}

export interface IContentAPIImageRef extends IContentAPIImageBaseRef {
    type?: string;
}